import { useEffect, useState } from "react";
import { getUser } from "../../auth";
import { Box } from "@mui/material";
import StockSummaryCard from "../components/StockSummaryCard";
import socket from "../../socket";


const URL = process.env.REACT_APP_API_URL;

export default function StockSummary() {
  const [summary, setSummary] = useState({
    total_stock: 0,
    low_stock_count: 0,
    out_of_stock_count: 0,
  });

  const fetchStockSummary = async () => {
    const user = getUser();
    try {
      const response = await fetch(
        `${URL}/api/stock/summary?empresa_id=${user.empresa_id}`
      );
      if (response.ok) {
        const data = await response.json();
        setSummary(data);
      } else {
        console.error("Error al obtener el resumen de stock");
      }
    } catch (error) {
      console.error("Error de red al obtener el resumen de stock", error);
    }
  };

  useEffect(() => {
    fetchStockSummary();

    socket.on("stock_creado_summary", () => {
      fetchStockSummary();
    })

    socket.on("stock_entrada_registrada_summary", () => {
      fetchStockSummary();
    })

    socket.on("stock_eliminado_summary", () => {
      fetchStockSummary();
    })

    return () => {
      socket.off("stock_creado_summary");
      socket.off("stock_entrada_registrada_summary");
      socket.off("stock_eliminado_summary");
    }
  }, []);



  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
      }}
    >
      <StockSummaryCard title={"Stock total (unidades)"} value={summary.total_stock} icon={"total_stock"}/>
      <StockSummaryCard title={"Productos con bajo stock"} value={summary.low_stock_count} icon={"low_stock_count"}/>
      <StockSummaryCard title={"Productos sin stock"} value={summary.out_of_stock_count} icon={"out_of_stock_count"} />
    </Box>
  )
}